import type { WorkspaceKey } from '@festina-life/api'
import { toast } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { useCallback } from 'react'

import { useWorkspaceManagerContext } from '../../../../workspace/workspaceManagerContext'
import { useInvalidateWorkspaceAfterHistoryRewrite } from './useInvalidateWorkspaceAfterHistoryRewrite'

export const useRebaseWorkspace = () => {
  const { onUpdate } = useWorkspaceManagerContext()
  const translate = useTranslate()
  const invalidateWorkspace = useInvalidateWorkspaceAfterHistoryRewrite()

  return useCallback(
    async (workspaceKey: WorkspaceKey) => {
      if (workspaceKey) {
        await onUpdate(
          {
            branchKey: workspaceKey.branchKey,
            name: workspaceKey.name,
          },
          false, // We do a cache invalidation below, so we can skip it here to avoid redundant cache updates.
        )

        await invalidateWorkspace(workspaceKey)

        toast({
          title: translate('workspaceDetailsPanel.toast.rebased', {
            branchName: workspaceKey.branchKey.name,
            workspaceName: workspaceKey.name,
          }),
          variant: 'success',
        })
      }
    },
    [onUpdate, invalidateWorkspace, translate],
  )
}
